<template>
  <v-dialog v-model="acknowledgeDialog" persistent max-width="400">
    <v-card>
      <v-card-title class="text-h5">
        {{ $t('acknowledge.title') }}
      </v-card-title>
      <v-card-text v-html="$t('acknowledge.hint', { documentTitle: acknowledgeDocumentTitle })"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="acknowledgeLater()">
          {{ $t('later') }}
        </v-btn>

        <v-btn text @click="acknowledge">
          {{ $t('acknowledge.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import acknowledgeService from '@/services/acknowledgeService';

export default {
  name: 'AcknowledgeDialog',
  mixins: [common],
  computed: {
    ...mapState({
      storeModule: (state) => (state.acknowledgeDocument && state.acknowledgeDocument.storeModule) || null,
      acknowledgeDocument: (state) => (state.acknowledgeDocument && state.acknowledgeDocument.document) || null,
    }),
    ...mapState('documents', ['documents']),
    acknowledgeDocumentTitle() {
      return this.acknowledgeDocument ? this.acknowledgeDocument.title : '';
    },
    acknowledgeDialog: {
      get() {
        return this.$store.state.acknowledgeDialog;
      },
      set(value) {
        console.debug('setAcknowledgeDialog', value);
        this.$store.commit('setAcknowledgeDialog', { value });
      },
    },
  },
  methods: {
    acknowledgeLater() {
      if (this.acknowledgeDocument) {
        this.$store.commit('setAcknowledgeDialog', { value: false, acknowledgeCompleted: true });
      }
    },
    acknowledge() {
      console.debug('acknowledge', JSON.stringify(this.acknowledgeDocument, null, 2));
      if (this.acknowledgeDocument) {
        let sendboxTitle = this.acknowledgeDocument.title;
        let snackbarText = this.$t('action.acknowledge.msg', { object: this.acknowledgeDocument.title });

        this.$store.dispatch(`sendbox/markAsAcknowledged2`, { item: this.acknowledgeDocument, sendboxTitle, snackbarText });
        this.$store.commit('setAcknowledgeDialog', { value: false, acknowledgeCompleted: true });
      }
    },
  },
};
</script>
